import React, {Component} from "react";
import {Link} from "react-router-dom";
import HeaderRight from "../layouts/HeaderRight";
import {post} from './../../networking/Api'
import Constent from './../../networking/Constent';
import {Alert} from "./../../alertServices";
import { withTranslation } from 'react-i18next';
import helpers from '../../networking/Helpers';

const statusDropdown = helpers.taskStatusList();
const percentList=helpers.percentList();
const PriorityDropdown = helpers.taskPriorityList();
const tasktypeDropdown = helpers.taskTypeList();
class ProjectTaskAdd extends Component {
    constructor(props) {
    	super(props);
    	this.state={
    		userList:[],
          	project_id:props.match.params.id,

	        taskStatus:1,
	        taskDone:0,
	        taskPriority:1,
	        taskType:3,
	        subject:'',
	        assignTo:'',
	        allocatedHrs:'',
	        startDate:'',
	        description:'',
	        dueDate:'',
        }
        this.handleChange2 = this.handleChange2.bind(this);
    }
	
	componentDidMount(){
  		this.getUserList();  
	}

	handleChange2(event) {
      const files = event.target.files;
	      for (let i = 0; i < files.length; i++) {
	       this.state.file=files;
	    };
	}    

    getUserList= () => {
    	var formData=new FormData();
    	formData.append("department",localStorage.getItem('department_id'));
	    post(Constent.GETDEPARTMENTCONTACT,formData)
	    .then(response=>{
	        if(response.status===1){
	          	this.setState({userList:response.data});
	        }else{
	        	Alert.error(response.message);
	        }
	    });    
	}

    handleAdd = () => {
	    var formData=new FormData();
	    let userID= localStorage.getItem('userid');
	    formData.append("user_id",userID);
	    formData.append("project_id",this.state.project_id);
		formData.append("subject",this.state.subject);
	    formData.append("type",this.state.taskType);
	    formData.append("task_assignees[0]",this.state.assignTo);
	    formData.append("priority",this.state.taskPriority);
	    formData.append("status",this.state.taskStatus);
	    formData.append("done_percent",this.state.taskDone);
	    formData.append("allocated_hrs",this.state.allocatedHrs);
	    formData.append("start_date",this.state.startDate);
	    formData.append("due_date",this.state.dueDate);
	    formData.append("description",this.state.description);
	   	const files = this.state.file;

      	for (let i = 0; i < files.length; i++) {
	         formData.append(`filename[${i}]`, files[i])
	    } 
    	const config = {
	        headers: {
	            'content-type': 'multipart/form-data'
	        }
	    }
	    post(Constent.TASKADD,formData,config).then(response =>{
	      if(response.status===1){
	      	Alert.success({title: response.message});
	        this.props.history.push('/project-details/'+this.state.project_id);
	      }else{
	        Alert.error({title: response.message});
	      }   
	    })
  };

	render() {
		const { t } = this.props;
	return(
		<>
            <div className="header-area projectlist-page" style={{'borderRadius': 0}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-3 col-3">
                                <Link className="menu-back-page home-clicked" to={'/'}>
                                    <i className="fa fa-home" />
                                </Link>
                            </div>
                            <div className="col-sm-6 col-6 text-center">
                                <div className="page-name">{t('lang.project_sc_add_task')}</div>
                            </div>
                            <div className="col-sm-3 col-3 text-right">
                               <HeaderRight />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mg-top-30 projectlist-page sub-header"></div>

                <div className='projectlist-page mg-bottom-40 container'>
                    <div style={{marginTop:20}}>
                        <div className="action-sheet-content">
                        		<span className="label">{t('lang.project_sc_subject')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    value={this.state.subject}
                                    onChange={e => { this.setState({subject: e.target.value})}} />
                                </div>

                        		<span className="label">{t('lang.project_sc_type')}</span>
                        		<div className="input-group mb-4">
	                        		<select className="form-control" 
			                        value={this.state.taskType}
			                        onChange={e => { this.setState({taskType: e.target.value})}}
			                        >
			                        {tasktypeDropdown.map(option => (
			                            <option value={option.value} key={Math.random()}>{option.label}</option>
			                        ))}
			                        </select>
			                    </div>

			                    <span className="label">{t('lang.common_text_status')}</span>
                        		<div className="input-group mb-4">
	                        		<select className="form-control" 
			                        value={this.state.taskStatus}
			                        onChange={e => { this.setState({taskStatus: e.target.value})}}
			                        >
			                        {statusDropdown.map(option => (
			                            <option value={option.value} key={Math.random()}>{option.label}</option>
			                        ))}
			                        </select>
			                    </div>

			                    <span className="label">{t('lang.project_sc_priority')}</span>
                        		<div className="input-group mb-4">
	                        		<select className="form-control" 
			                        value={this.state.taskPriority}
			                        onChange={e => { this.setState({taskPriority: e.target.value})}} >
			                        {PriorityDropdown.map(option => (
			                            <option value={option.value} key={Math.random()}>{option.label}</option>
			                        ))}
			                        </select>
			                    </div>

			                    <span className="label">{t('lang.project_sc_affectivity')}</span>
                        		<div className="input-group mb-4">
	                        		<select className="form-control" 
			                        value={this.state.taskDone}
			                        onChange={e => { this.setState({taskDone: e.target.value})}} >
			                        {percentList.map(option => (
			                            <option value={option.value} key={Math.random()}>{option.label}</option>
			                        ))}
			                        </select>
			                    </div>

			                    <span className="label">{t('lang.project_sc_assign_to')}</span>
                        		<div className="input-group mb-4">
	                        		<select className="form-control" 
			                        value={this.state.assignTo}
			                        onChange={e => { this.setState({assignTo: [e.target.value]})}} >
			                        {this.state.userList.map(option => (
			                            <option value={option.id} key={Math.random()}>{option.full_name}</option>
			                        ))}
			                        </select>
			                    </div>

                                <span className="label">{t('lang.project_sc_allocated_hrs')}</span>
                                <div className="input-group mb-4">
                                    <input type="number" className="form-control form-control-lg"
                                    value={this.state.allocatedHrs}
                                    step="0.1"
				                    min='0'
				                    max='24'
                                    onChange={e => { this.setState({allocatedHrs: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.project_sc_flex_start_date')}</span>
                                <div className="input-group mb-4">
                                    <input type="date" className="form-control form-control-lg"
                                    value={ this.state.startDate }
                                    onChange={e => { this.setState({startDate: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.project_sc_due_date')}</span>
                                <div className="input-group mb-4">
                                    <input type="date" className="form-control form-control-lg"
                                    value={ this.state.dueDate }
                                    onChange={e => { this.setState({dueDate: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.project_sc_description')}</span>
                                <div className="input-group mb-4">
                                	<textarea className="form-control form-control-lg"
                                    value={this.state.description} 
                                    rowSpan="4"
                                    onChange={e => { this.setState({description: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.project_sc_file')}</span>
                                <div className="input-group mb-4">
                                    <input type="file" 
                                    className="form-control form-control-lg"
                                    multiple
                                    onChange={this.handleChange2}
                                     />
                                </div>

                            </div>
                            <button type="button" className="btn-c btn-primary btn-block mb-2" onClick={this.handleAdd}>{t('lang.modal_btn_save')}</button>
                    	<br></br>
                    </div>
                </div>
            {/* transaction End */}
           
    
            {/* Footer start */}
                <div className="footer-area">
                    <div className="container">
                        <div className="footer-bottom text-center">
                            <div className="row center">
                               <div className="col-8 offset-2 center">
                                    
                                </div>
                                <div className="col-2">
                                    <Link className="home-clicked" to={'/project-details/'+this.state.project_id}>
	                                    <i className="fa fa-reply" />
	                                </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Footer End */}
        </>        
	)
	}
}

export default (withTranslation('common')(ProjectTaskAdd))